// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://stripe.com/docs/payments/accept-a-payment#web

import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { CardElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

export const CheckoutForm = ({ doValidate, donationID }) => {
  const stripe = useStripe();
  const elements = useElements();
  const config = useStoreState((state) => state.config);
  const openInfoPopup = useStoreActions((action) => action.open);
  const showSpinner = useStoreActions((action) => action.showSpinner);
  const hideSpinner = useStoreActions((action) => action.hideSpinner);

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();
    showSpinner();
    const validationResult = await doValidate();
    if (!validationResult.result) {
      // Stripe.js has not loaded yet. Make sure to disable
      hideSpinner();
      openInfoPopup({ notice: validationResult.notice, reload: false, btnName: 'OK' });
      return;
    }

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const returnUrl = config.frontDomain + 'thank-you/donation/' + donationID;
    const result = await stripe.confirmPayment({
      // `Elements` instance that was used to create the Payment Element

      elements,
      confirmParams: {
        return_url: returnUrl,
      },
    });
    hideSpinner();
    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      openInfoPopup({ notice: result.error.message, reload: false, btnName: 'OK' });
      console.log(result.error.message);
    } else {
      console.log('payment result', result);
    }
  };

  React.useEffect(() => {
    console.log('stripe donationID', donationID);
  }, [stripe]);

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <div className="form-button ">
        <button className="form-btn form-btn--block form-btn--info" type="submit">Submit</button>
      </div>
    </form>
  );
};
